"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("./styles");
var Layout_1 = __importDefault(require("../context/Layout"));
var CultureCloudWhiteLogo_1 = __importDefault(require("./CultureCloudWhiteLogo"));
var LogoLink = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var handleNavigation = _a.handleNavigation, isCultureCloud = _a.isCultureCloud;
    var _h = __read((0, react_1.useContext)(Layout_1.default), 2), currentIdentityQuery = _h[0], layoutQuery = _h[1];
    var customerName = (_d = (_c = (_b = currentIdentityQuery === null || currentIdentityQuery === void 0 ? void 0 : currentIdentityQuery.data) === null || _b === void 0 ? void 0 : _b.currentIdentity) === null || _c === void 0 ? void 0 : _c.customer) === null || _d === void 0 ? void 0 : _d.name;
    var logoValue = (_g = (_f = (_e = layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data) === null || _e === void 0 ? void 0 : _e.theme) === null || _f === void 0 ? void 0 : _f.logo) === null || _g === void 0 ? void 0 : _g.value;
    var isCurrentPage = function (url) { return window.location.pathname === url; };
    if (isCultureCloud) {
        return (react_1.default.createElement(styles_1.LogoCell, null,
            react_1.default.createElement(styles_1.StyledCultureCloudLogoLink, { href: "/", onClick: handleNavigation('/'), "aria-label": "Culture Cloud logo. ".concat(isCurrentPage('/') ? 'Same Page' : 'Go to Home Page') },
                react_1.default.createElement(CultureCloudWhiteLogo_1.default, null))));
    }
    return (react_1.default.createElement(styles_1.HeaderCell, null, !logoValue ? (react_1.default.createElement(styles_1.StyledSkeleton, { "data-testid": "logo-skeleton" })) : (react_1.default.createElement(styles_1.StyledLogoLink, { href: "/", onClick: handleNavigation('/'), "aria-label": "".concat(customerName || 'Company', " logo. ").concat(isCurrentPage('/') ? 'Same Page' : 'Go to Home Page') },
        react_1.default.createElement(styles_1.StyledLogoImage, { src: logoValue, alt: "".concat(customerName || 'Company', " logo") })))));
};
exports.default = LogoLink;
//# sourceMappingURL=LogoLink.js.map